import Vue from 'vue';
import VueRouter from 'vue-router';
import HomePage from '../pages/HomePage.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Root',
    component: HomePage
  },
  {
    path: '/homepage',
    redirect: '/'
  }
];

const router = new VueRouter({
  mode: 'hash',
  routes
});

export default router;